import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import UploadModalContent from './upload-modal/upload-modal';

export const UploadModal = ({ report, item, show, onClose }) => (
  <Modal show={show} onHide={onClose} dialogClassName="maker-upload-modal modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>Upload Document</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <UploadModalContent context={{ report, item }} onClose={onClose} />
    </Modal.Body>
  </Modal>
);

export const InfoModal = ({ show, title, message, onClose }) => (
  <Modal show={show} onHide={onClose} backdrop="static" dialogClassName="modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export const CommentModal = ({ show, comment, onClose }) => (
  <Modal show={show} onHide={onClose} backdrop="static" dialogClassName="commentModal modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>Report Comment</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{comment || 'No Comments'}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
);
